import {FileDto} from '../dtos/FileDto';

export class GovServiceApplication {
  public serviceId: number;
  public collegeId: number;
  public lastName: string;
  public firstName: string;
  public patronymic: string;
  public email: string;
  public phone: string;
  public iin: string;
  public signedXml: string;

  constructor(collegeId, serviceId, iin) {
    this.collegeId = collegeId;
    this.serviceId = serviceId;
    this.iin = iin;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/models/gov-service-application.ts